import React, { useEffect, useState } from "react";
import { API_BASE_URL, EDIT_MASTER_SPECIALITY } from "../services/end_points";
import { _put } from "../services/service_api";
import { Alert, Button, Col, Form, Input, Row } from "antd";

const EditSpeciality = ({ data }) => {
  const [alert, setAlert] = useState(null);
  const [editing] = useState(true);
  const [formdata, setFormdata] = useState({
    masterSpeciality: editing ? data.specialities_names : "",
  });
  const [success, setSuccess] = useState(false);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  useEffect(() => {
    setFormdata({ masterSpeciality: data.specialities_names });
  }, [data]);
  const handleReset = () => {
    setFormdata({ masterSpeciality: "" });
  };
  const handleSpeciality = async (e) => {
    e.preventDefault();
    const id = data.id;
    try {
      const response = await _put(
        `${API_BASE_URL}${EDIT_MASTER_SPECIALITY}${id}`,
        formdata
      );
      window.location.reload();
      setFormdata({ masterSpeciality: "" });
      setAlert({ type: "success", message: "Speciality Updated" });
      setSuccess(true);
    } catch (err) {
      console.error("Error updating city:", err);
      setAlert({ type: "error", message: "Failed to update speciality" });
      setSuccess(false);
    }
  };
  return (
    <>
      <Row>
        <Form onFinish={handleSpeciality} layout="vertical">
          <div>
            <div>
              {alert && (
                <div>
                  <Alert
                    type="success"
                    style={{
                      backgroundColor: "#dbffb8cf",
                      color: "black",
                      width: "100%",
                      marginTop: "0.5rem",
                      marginBottom: "2rem",
                    }}
                    message={"City Updated!"}
                  />
                </div>
              )}
            </div>

            <Col
              md={20}
              xl={24}
              lg={24}
              sm={24}
              style={{
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Form.Item label="Add Speciality Name" required>
                <Input
                  id="specialitiesName"
                  name="masterSpeciality"
                  value={formdata.masterSpeciality}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "1rem", // Adjust spacing as needed
                  width: "20vw",
                }}
              >
                <Button
                  type="button"
                  onClick={handleReset}
                  style={{
                    color: "black",
                    border: "solid #1236fa",
                    marginRight: "auto",
                    width: "85px",
                    height: "32px",
                    borderRadius: "3vw",
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  onClick={handleSpeciality}
                  style={{
                    color: "white",
                    background: "#1236fa",
                    width: "85px",
                    height: "32px",
                    borderRadius: "3vw",
                  }}
                >
                  Submit
                </Button>
              </div>
            </Col>
          </div>
        </Form>
      </Row>
    </>
  );
};
export default EditSpeciality;
